import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import { ListarEtapasRepasseController } from "../../../../Controllers/Geral/Etapas/EtapasControllers";
import { ListarCategoriaRepasseController } from "../../../../Controllers/Geral/GestaoDeCadastros/CategoriaAtendimento";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { ListarEmpreendimentosPesquisaController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { ListarEquipesDeVendasController } from "../../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import { IGestaoRepasseFiltro } from "../../../../Interfaces/Repasse/GestaoRepasse/GestaoRepasseInterfaces";
import StorageManagerCapys from "../../../../Tools/Storage";
import { formatterCPF_CNPJ } from "../../../../Validations/InputMasks";

interface IGestaoRepasseProps {
    handleSubmit: (filter: IGestaoRepasseFiltro) => void;
    defaultFilter?: IGestaoRepasseFiltro;
    storageManager: StorageManagerCapys<IGestaoRepasseFiltro | undefined>;
    setIdEmpreendimento: Dispatch<SetStateAction<string | number>>;
}

export default function FiltroGestaoRepasse(props: IGestaoRepasseProps) {
    const filter = props.defaultFilter;
    const hadleFilterFormSubmit = props.handleSubmit;
    const FormMethods = useForm();
    const { reset, setValue } = FormMethods;

    const limparFiltro = {
        DS_NOME_CONTA: "",
        DS_NOME_CONTATO: "",
        DS_STATUS_CASO: "",
        DT_FINAL_FN: "",
        DT_FINAL_IN: "",
        DT_INICIAL_FN: "",
        DT_INICIAL_IN: "",
        FL_ANDAMENTO: 0,
        ID_ACOMPANHAMENTO: 0,
        ID_CASO: "",
        ID_CATEGORIA_ATENDIMENTO: 0,
        ID_CONTA: 0,
        ID_EMPREENDIMENTO: [],
        ID_EQUIPE_VENDAS: 0,
        ID_ETAPA_CATEGORIA_ATENDIMENTO: "",
        ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: "",
        ID_USUARIO_RESPONSAVEL: "",
        NR_CPF: "",
    };

    return (
        <StickyToolbar active={Boolean(filter)}>
            <FormProvider {...FormMethods}>
                <UnForm
                    handleSubmit={hadleFilterFormSubmit}
                    className="form-group row"
                    usingContext
                >
                    <div className="col-12 mt-3">
                        <label>Data Inicio do Atendimento</label>
                        <div className="row">
                            <div className="col-6">
                                <UnForm.Input
                                    className="form-control"
                                    type="date"
                                    defaultValue={filter?.DT_INICIAL_IN}
                                    name="DT_INICIAL_IN"
                                />
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    className="form-control"
                                    type="date"
                                    defaultValue={filter?.DT_INICIAL_FN}
                                    name="DT_INICIAL_FN"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Data Fim do atendimento</label>
                        <div className="row">
                            <div className="col-6">
                                <UnForm.Input
                                    className="form-control"
                                    type="date"
                                    defaultValue={filter?.DT_FINAL_IN}
                                    name="DT_FINAL_IN"
                                />
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    className="form-control"
                                    type="date"
                                    defaultValue={filter?.DT_FINAL_FN}
                                    name="DT_FINAL_FN"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Status do Caso</label>
                        <UnForm.Select
                            className="form-control"
                            name="DS_STATUS_CASO"
                            defaultValue={filter?.DS_STATUS_CASO ?? "Aberto"}
                        >
                            <option></option>
                            <option>Aberto</option>
                            <option>Fechado</option>
                        </UnForm.Select>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Empreendimento</label>
                        <UnForm.SearchSelect
                            controller={(searchValue: string) =>
                                ListarEmpreendimentosPesquisaController(
                                    searchValue ?? ""
                                )
                            }
                            {...FormMethods}
                            name="ID_EMPREENDIMENTO"
                            getDS={(e) => e.DS_EMPREENDIMENTO}
                            getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                            onChange={(e) => props.setIdEmpreendimento(e)}
                            mode="multiple"
                            buscarEmpreendimento={true}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label>CPF/CNPJ</label>
                        <UnForm.Input
                            onChange={formatterCPF_CNPJ}
                            className="form-control"
                            type="text"
                            maxLength={14}
                            name="NR_CPF"
                            defaultValue={filter?.NR_CPF}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label>Protocolo</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            name="ID_CASO"
                            defaultValue={filter?.ID_CASO}
                        />
                    </div>

                    <div className="col-12 mt-3">
                        <label>Atendente</label>
                        <UnForm.LazySelect
                            className="form-control"
                            name="ID_USUARIO_RESPONSAVEL"
                            controller={ListarUsuariosController}
                            filter={(u) => u.FL_ATIVO}
                            getDS={(u) => u.DS_NOME}
                            getKeyValue={(u) => u.ID_USUARIO}
                            defaultValue={filter?.ID_USUARIO_RESPONSAVEL}
                            setValue={setValue}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>

                    <div className="col-12 mt-3">
                        <label>Cliente</label>
                        <UnForm.Input
                            className="form-control"
                            type="text"
                            name="DS_NOME_CONTA"
                            defaultValue={filter?.DS_NOME_CONTA}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label>Contato</label>
                        <UnForm.Input
                            className="form-control"
                            type="text"
                            name="DS_NOME_CONTATO"
                        />
                    </div>

                    <div className="col-12 mt-3">
                        <UnForm.LazySelect
                            label={"Equipe Vendas"}
                            className={`form-control placeholder-dark-75`}
                            name="ID_EQUIPE_VENDAS"
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                            {...FormMethods}
                            defaultValue={filter?.ID_EQUIPE_VENDAS}
                            controller={ListarEquipesDeVendasController}
                            getDS={(s) => s.DS_EQUIPE_VENDAS}
                            getKeyValue={(s) => s.ID_EQUIPE_VENDAS}
                        >
                            <option value={0}></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.LazySelect
                            label="Categoria de Atendimento"
                            name="ID_CATEGORIA_ATENDIMENTO"
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                            {...FormMethods}
                            controller={ListarCategoriaRepasseController}
                            getDS={(s) => s.DS_CATEGORIA_ATENDIMENTO}
                            getKeyValue={(s) => s.ID_CATEGORIA_ATENDIMENTO}
                        >
                            <option value={0}></option>
                        </UnForm.LazySelect>
                    </div>

                    <div className="col-12 mt-3">
                        <label>Etapa</label>
                        <UnForm.LazySelect
                            controller={ListarEtapasRepasseController}
                            getDS={(e) =>
                                e.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                            }
                            getKeyValue={(e) =>
                                e.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                            }
                            fatherName="ID_CATEGORIA_ATENDIMENTO"
                            name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark mt-2"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            onClick={() => {
                                window.sessionStorage.removeItem(
                                    "FILTRO_GESTAO_REPASSE"
                                );
                                reset(limparFiltro);
                            }}
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </StickyToolbar>
    );
}
